module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intalent__content"
  }, [(_vm.process) ? _c('ModalDefault', {
    attrs: {
      "fullscreen": true,
      "transition": "zoom"
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "intalent__wait"
  }, [_c('SpinnerInlerno', {
    attrs: {
      "size": "100"
    }
  })], 1), _c('iframe', {
    staticClass: "intalent__iframe",
    class: {
      'intalent__iframe_hidden': _vm.wait
    },
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "no"
    },
    on: {
      "load": _vm.onLoad
    }
  })]) : _vm._e(), _c('button', {
    staticClass: "intalent__content-button",
    attrs: {
      "disabled": _vm.process
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57fb300c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/intalent/test/component.vue
// module id = 1f947743183cf0a0b10e
// module chunks = 0